<template>
   <m-geo-box geo-option="zip" title="ZIP Code Rage">
     <span slot="menu">
       <m-geo-zip-menu></m-geo-zip-menu>
     </span>
     <div class="zip-box">
      <b-input v-model="zipFrom"
               type="number"
               class="zip-input"></b-input>
      <b-input v-model="zipTo"
               type="number"
               class="zip-input zip-to"></b-input>
     </div>
      <b-btn @click="addZip">Add</b-btn>


   </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoZipMenu from '@/components/geo/MGeoZipMenu'

  export default {
    components: {
      MGeoBox,
      MGeoZipMenu
    },
    data () {
      return {
        zipFrom: '',
        zipTo: '',
        a: ''
      }
    },
    computed: {
      geoType () {
        return this.$store.state.geo.geoTypes.Zip
      }
    },
    methods: {
      validZip (zips) {
        // zips = utils.validZip(codes, type) TODO@PONY need check
        this.$http.post('PlaceOrder.aspx/GetZipsByZips', {
          zipType: 0,
          zips: zips
        }).then(resp => {
          // add zip to order
          let zips = resp.body.d.DataSource
          for (let zip of zips) {
            this.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5
            })
          }
        })
      },
      addZip () {
        this.$store.dispatch('order/changeGeoType', this.geoType.Code)
        this.$http.post('PlaceOrder.aspx/GetZipcodesByRange', {
          fromZipcode: this.zipFrom,
          toZipcode: this.zipTo,
          maxLength: 2000
        }).then(resp => {
          this.validZip(resp.body.d.DataSource)
          this.zipFrom = ''
          this.zipTo = ''
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .zip-input {
    width: 120px;
    display: inline-block;
  }
  .zip-box {
    margin-bottom: 16px;
  }
  .zip-to {
    margin-left: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoZipRange.vue